import {
  CATEGORY_COLOR_MAP,
  resolveSectionColor,
  SECTION_FALLBACK_COLOR,
} from './sectionColors';

// Types
export interface Category {
  name: string;
  color: string;
  description?: string;
}

const DESCRIPTIONS: Record<string, string> = {
  Engine: 'Internal engine components, pistons, rods, etc.',
  Turbo: 'Turbocharger, intercooler, piping',
  Drivetrain: 'Transmission, diffs, axles, clutch',
  'Fuel System': 'Injectors, fuel pump, lines, rails',
  Cooling: 'Radiator, fans, cooling system',
  Suspension: 'Coilovers, springs, sway bars',
  Brakes: 'Brake pads, rotors, calipers',
  Wheels: 'Wheels, tires, wheel hardware',
  Exhaust: 'Exhaust system, downpipe, catback',
  Interior: 'Seats, gauges, interior modifications',
  Exterior: 'Body kit, spoilers, exterior mods',
  Electronics: 'ECU, wiring, sensors, electronics',
  Miscellaneous: 'Other modifications and services',
};

/**
 * Restrained Bilt chrome accents — warm neutrals + orange family.
 * Map lives in sectionColors.ts (keep aligned with packages/design-tokens).
 */
export const categories: Category[] = (
  [
    'Engine',
    'Turbo',
    'Drivetrain',
    'Fuel System',
    'Cooling',
    'Suspension',
    'Brakes',
    'Wheels',
    'Exhaust',
    'Interior',
    'Exterior',
    'Electronics',
    'Miscellaneous',
  ] as const
).map((name) => ({
  name,
  color: CATEGORY_COLOR_MAP[name] || SECTION_FALLBACK_COLOR,
  description: DESCRIPTIONS[name],
}));

export const getCategoryColor = (categoryName: string): string =>
  resolveSectionColor(categoryName);

export const getCategoryNames = (): string[] => categories.map((cat) => cat.name);
